/* eslint-disable import/prefer-default-export */
export const NAME = 'layout'
